<template>
  <modal class="modal" name="signup-modal" transition="pop-out" :width="modalWidth" height="auto" :scrollable="true" :adaptive="true" @opened="opened" @before-close="beforeClose">
    <div class="flex flex-column items-center modal bg-tertiary textColor">
      <div class="flex justify-end w-100">
        <a @click="closeModal" class="pa3 pointer textColor">
          <font-awesome-icon icon="times" />
        </a>
      </div>
      <div class="flex justify-center fl w-30 pb2">
        <img class="h-100 w-100" src="../../../assets/logo-white.svg" alt="BeatHey Logo">
      </div>
      <div class="mv2">
        <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
      </div>
      <div class="mh5">
        <p class="errorText mh3 tc f7" v-if="error && input === ''">{{error}}</p>
        <form @submit.prevent="modalRegister(username, email, pass, day, month, year, userType, voucher)">
          <div class="flex flex-column f6">
            <div class="flex-ns justify-center">
              <div class="w-50-ns w-100 ph2-ns">
                <span class="errorText f7" v-if="$v.username.$error && !$v.username.required">{{ $t('error.usernameRequired') }}</span>
                <span class="errorText f7" v-if="error && input === 'username'">{{error}}</span>
                <input class="w-100 mv2 block ph1 pv2 bg-tertiary" :class="{error: $v.username.$error || (error && input === 'username'), 'input-margin': $v.pass.$error && !$v.username.$error}"
                @blur="$v.username.$touch" v-model="username" type="text" name="username" id="username" :placeholder="$t('users.username')">
              </div>
              <div class="w-50-ns w-100 ph2-ns">
                <span class="errorText f7" v-if="$v.pass.$error && !$v.pass.required">{{ $t('error.passwordRequired') }}</span>
                <input class="w-100 mv2 block ph1 pv2 bg-tertiary" :class="{error: $v.pass.$error, 'input-margin': !$v.pass.$error && ($v.username.$error || (error && input === 'username'))}"
                 @blur="$v.pass.$touch" v-model="pass" type="password" name="password" id="password" :placeholder="$t('users.password')">
              </div>
            </div>
            <div class="flex-ns justify-center">
              <div class="w-50-ns w-100 ph2-ns">
                <span class="errorText f7" v-if="$v.dni.$error && !$v.dni.required">{{ $t('error.idRequired') }}</span>
                <span class="errorText f7" v-if="$v.dni.$error && !$v.dni.minLength"> {{ $t('error.shortId') }}</span>
                <span class="errorText f7" v-if="error && input === 'dni'">{{error}}</span>
                <input class="w-100 mv2 block ph1 pv2 bg-tertiary" :class="{error: $v.dni.$error, 'input-margin': $v.phone.$error && !$v.dni.$error}"
                @blur="$v.dni.$touch" v-model="dni" type="text" name="dni" id="dni" :placeholder="$t('users.id')">
              </div>
              <div class="w-50-ns w-100 ph2-ns">
                <span class="errorText f7" v-if="$v.phone.$error && !$v.phone.numeric">{{ $t('error.phoneInvalid') }}</span>
                <input class="w-100 mv2 block ph1 pv2 bg-tertiary" :class="{error: $v.phone.$error, 'input-margin': $v.dni.$error && !$v.phone.$error}"
                @blur="$v.phone.$touch" v-model="phone" type="text" name="phone" id="phone" :placeholder="$t('users.phone')">
              </div>
            </div>
            <div class="flex-ns db justify-center">
              <div class="w-50-ns w-100 ph2-ns">
                <span class="errorText f7" v-if="error && input === 'email'">{{error}}</span>
                <span class="errorText f7" v-if="$v.email.$error && !$v.email.required">{{ $t('error.emailRequired') }}</span>
                <span class="errorText f7" v-if="$v.email.$error && !$v.email.email">{{ $t('error.emailInvalid') }}</span>
                <input class="w-100 mv2 block ph1 pv2 bg-tertiary" :class="{'error': $v.email.$error || (error && input === 'email'), 'input-margin': $v.email2.$error && !$v.email.$error}"
                @blur="$v.email.$touch" v-model="email" type="text" name="email" id="email" :placeholder="$t('users.email')">
              </div>
              <div class="w-50-ns w-100 ph2-ns">
                <span class="errorText f7" v-if="$v.email2.$error && !$v.email2.required">{{ $t('error.confirmEmailRequired') }}</span>
                <span class="errorText f7" v-if="$v.email2.$error && !$v.email2.sameAs && $v.email2.required">{{ $t('error.confirmEmailInvalid') }}</span>
                <input class="w-100 mv2 block ph1 pv2 bg-tertiary" :class="{error: $v.email2.$error, 'input-margin': ($v.email.$error ||(error && input === 'email')) && !$v.email2.$error}"
                @blur="$v.email2.$touch"
                v-model="email2" type="text" name="email2" id="email2" :placeholder="$t('users.emailConfirmation')">
              </div>
            </div>
            <div class="flex">
              <span class="errorText f7 mh2-ns" v-if="$v.address.$error && !$v.address.required">{{ $t('error.addressRequired') }}</span>
              <span class="errorText f7" v-if="error && input === 'address'">{{error}}</span>
            </div>
            <input class="mv2 mh2-ns block ph1 pv2 bg-tertiary" :class="{error: $v.address.$error}" @blur="$v.address.$touch"
            v-model="address" type="text" name="address" id="address" :placeholder="$t('users.address')">
            <div class="flex">
              <span class="errorText f7 mh2-ns" v-if="($v.day.$error && !$v.day.required) || ($v.month.$error && !$v.month.required) ||
              ($v.year.$error && !$v.year.required)">{{ $t('error.birthdateRequired') }}</span>
            </div>
            <label class="mt2 mh2-ns">{{ $t('users.birthdate') }}</label>
            <div class="flex-ns justify-between items-center">
              <select class="w-third-ns w-100 mv2 mh2-ns block ph1 pv2 bg-tertiary textColor" :class="{error: $v.day.$error}" @blur="$v.day.$touch"
              v-model="day" id="birth-day">
                <option value="" selected>{{ $t('users.day') }}</option>
                <option v-for="n in 31" :track-by="n" :key="n" :value="n">{{n}}</option>
              </select>
              <select class="w-third-ns w-100 mv2 mh2-ns block ph1 pv2 bg-tertiary textColor" :class="{error: $v.month.$error}" @blur="$v.month.$touch"
              v-model="month" id="birth-month">
                <option value="" selected>{{ $t('users.month') }}</option>
                <option v-for="(month, index) in months" :track-by="index" :key="index" :value="index">{{month}}</option>
              </select>
              <select class="w-third-ns w-100 mv2 mh2-ns block ph1 pv2 bg-tertiary textColor" :class="{error: $v.year.$error}" @blur="$v.year.$touch"
              v-model="year" id="birth-year">
                <option value="" selected>{{ $t('users.year') }}</option>
                <option v-for="n in 70" :track-by="n" :key="n" :value="n+1940">{{n+1940}}</option>
              </select>
            </div>
            <div class="flex-ns db justify-between items-center">
              <label class="mv2 mh2-ns">
                <strong>{{ $t('users.voucher') }}</strong>
              </label>
              <div class="flex flex-column w-50-ns w-100">
                <span class="errorText f7 mh2-ns" v-if="$v.voucher.$error && !$v.voucher.minLength">{{ $t('error.shortVoucher') }}</span>
                <span class="errorText f7 mh2-ns" v-if="$v.voucher.$error && !$v.voucher.maxLength">{{ $t('error.longVoucher') }}</span>
                <span class="errorText f7 mh2-ns" v-if="error && input === 'voucher'">{{error}}</span>
                <input class="mv2 mh2-ns block ph1 pv2 bg-tertiary" :class="{error: $v.voucher.$error || error && input === 'voucher'}" @blur="$v.voucher.$touch"
                v-model="voucher" type="text" name="voucher" id="voucher" :placeholder="$t('users.code')">
              </div>
            </div>
            <div class="flex-ns justify-center items-center">
              <label class="ma2">
                <input v-model="userType" name="user_type" type="radio" value="0" checked>{{ $t('users.userType.musicFan') }}</label>
              <label class="ma2">
                <input v-model="userType" name="user_type" type="radio" value="1">{{ $t('users.userType.producer') }}</label>
            </div>
            <div class="flex items-center">
              <input class="ma2" type="checkbox" name="accept" id="accept" checked>
              <label class="ma2 f7" for="accept">{{ $t('users.registration.shareData') }}</label>
            </div>
            <p class="f7">{{ $t('users.registration.accept') }}
              <router-link class="textColor" :to="{ name: 'general-terms-' + language}" target="_blank">{{ $t('footer.termsOfUse') }}</router-link>
              <span>{{ $t('users.registration.comma') }}</span>
              <router-link class="textColor" :to="{ name: 'intellectual-prop-' + language}" target="_blank">{{ $t('footer.intellectuallyProp') }}</router-link>
              <span>{{ $t('users.registration.andThe') }}</span>
              <router-link class="textColor" :to="{ name: 'privacy-policy-' + language}" target="_blank">{{ $t('footer.privacyPolicy') }}</router-link>
            </p>
            <div class="flex justify-center">
              <input class="w-50-ns w-100 block mv2 pointer btn dim b f5 fw4" type="submit" :value="$t('users.registration.register')">
            </div>
            <p class="tc f7">{{ $t('users.registration.alreadyHaveAnAccount')}}
              <span @click="login" class="pointer">{{ $t('users.login') }}</span>
            </p>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import { required, email, numeric, sameAs, minLength, maxLength } from 'vuelidate/lib/validators'
  import { mapGetters, mapActions } from 'vuex'
  const MODAL_WIDTH = 600

  export default {
    name: 'signup-modal',
    components: {
      FontAwesomeIcon,
      ClipLoader
    },
    data () {
      return {
        modalWidth: MODAL_WIDTH,
        color: '#808080',
        size: '50px',
        months: this.$i18n.t('users.months'),
        username: '',
        pass: '',
        dni: '',
        phone: '',
        email: '',
        email2: '',
        address: '',
        day: '',
        month: '',
        year: '',
        userType: 0,
        voucher: ''
      }
    },
    created () {
      this.modalWidth = window.innerWidth < MODAL_WIDTH
        ? MODAL_WIDTH / 2
        : MODAL_WIDTH
    },
    computed: {
      ...mapGetters('user', [
        'error',
        'loading',
        'input',
        'validVoucher'
      ]),
      ...mapGetters('translator', [
        'language'
      ])
    },
    methods: {
      ...mapActions('user', [
        'register',
        'checkVoucher',
        'resetError'
      ]),
      closeModal () {
        this.$modal.hide('signup-modal')
        this.resetError()
      },
      login () {
        this.closeModal()
        this.$modal.show('login-modal')
      },
      modalRegister () {
        if (!this.$v.$invalid) {
          // var birthdate = new Date(this.year, this.month, this.day)
          this.checkVoucher(this.voucher).then(() => {
            if (this.validVoucher) {
              this.register({
                username: this.username,
                pass: this.pass,
                dni: this.dni,
                phone: this.phone,
                email: this.email,
                address: this.address,
                birthdate: this.year + '-' + (parseInt(this.month) + 1) + '-' + this.day,
                userType: this.userType,
                voucher: this.voucher
              }).then(() => {
                this.$modal.hide('signup-modal')
                this.$modal.show('subscription-modal')
              }).catch((e) => {
              })
            }
          })
        } else {
          this.$v.$touch()
        }
      },
      opened () {
        this.$v.$reset()
      },
      beforeClose () {
        this.resetError()
      }
    },
    validations: {
      username: {
        required
      },
      pass: {
        required
      },
      dni: {
        required,
        minLength: minLength(7)
      },
      phone: {
        numeric
      },
      email: {
        required,
        email
      },
      email2: {
        required,
        sameAsEmail: sameAs('email')
      },
      day: {
        required
      },
      month: {
        required
      },
      year: {
        required
      },
      address: {
        required
      },
      voucher: {
        minLength: minLength(10),
        maxLength: maxLength(15)
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '~@/variables.scss';
  .modal {
    z-index: 10000;
  }

  .input {
    box-sizing: border-box;
    line-height: 2;
  }

  .error {
    border: 1px solid $error-color;
  }

  .pop-out-enter-active,
  .pop-out-leave-active {
    transition: all 0.5s;
  }

  .pop-out-enter,
  .pop-out-leave-active {
    opacity: 0;
    transform: translateY(24px);
  }

  @media (min-width: 479px) {
    .input-margin{
      margin-top: 22px;
    }
  }
  
  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus, 
  input:-webkit-autofill:active  {
    -webkit-box-shadow: 0 0 0 30px $background-color inset ;
    -webkit-text-fill-color: $text-color;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/signup/SignupModal.vue